import { HTMLAttributes } from 'react';

interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  tagline?: string;
  logoUrl?: string | null;
}

const containerSizeClasses: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-10 w-10',
  md: 'h-14 w-14',
  lg: 'h-16 w-16',
};

const labelSizeClasses: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
};

const taglineSizeClasses: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'text-[0.55rem]',
  md: 'text-xs',
  lg: 'text-sm',
};

const DEFAULT_LOGO = '/logo.svg';

export default function Logo({
  size = 'md',
  showLabel = false,
  tagline = 'Workforce Intelligence',
  logoUrl,
  className = '',
  ...props
}: LogoProps) {
  const containerBase = showLabel ? 'flex items-center gap-3' : 'inline-flex';
  const imgSrc = logoUrl || DEFAULT_LOGO;

  return (
    <div className={`${containerBase} ${className}`} {...props}>
      <div className={`${containerSizeClasses[size]} rounded-xl overflow-hidden flex-shrink-0`}>
        <img 
          src={imgSrc}
          alt="ChannelPlex" 
          className="h-full w-full object-contain block"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            if (target.src !== window.location.origin + DEFAULT_LOGO) {
              target.src = DEFAULT_LOGO;
            }
          }}
        />
      </div>

      {showLabel && (
        <div className="flex flex-col">
          <span className={`font-semibold tracking-tight text-slate-900 ${labelSizeClasses[size]}`}>
            ChannelPlex
          </span>
          <span className={`uppercase tracking-[0.35em] text-primary-500 ${taglineSizeClasses[size]}`}>{tagline}</span>
        </div>
      )}
    </div>
  );
}
